export const LOADING_FLAG = 'loading_flag'
export const LOADING_TIP = 'loading_tip'
